import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFlashMessage } from "@/app/(main)/(club)/mes-clubs/[id]/components/use-flash-message";
import { useModalStore } from "@/stores/modal-store";
interface UpdateSettingsProps {
  clubSlug: string;
  settings: {
    dayWeek: number;
    startDate: string;
    openingTime: string;
    closingTime: string;
  };
}
export const useUpdateSettings = () => {
  const $ = _c(9);
  const queryClient = useQueryClient();
  const {
    showFlashMessage
  } = useFlashMessage();
  const {
    close
  } = useModalStore();
  let t0;
  if ($[0] !== close || $[1] !== queryClient) {
    t0 = (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["settings", variables.clubSlug]
      });
      setTimeout(() => {
        close();
      }, 3000);
    };
    $[0] = close;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== close || $[4] !== showFlashMessage) {
    t1 = error_0 => {
      console.error("Erreur lors de la modification:", error_0);
      showFlashMessage("Erreur lors de la modification des param\xE8tres", "danger", "mes-clubs-calendar");
      close();
    };
    $[3] = close;
    $[4] = showFlashMessage;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = {
      mutationFn: _temp,
      onSuccess: t0,
      onError: t1
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return useMutation(t2);
};
async function _temp(t0) {
  const {
    clubSlug,
    settings
  } = t0;
  const response = await fetch("/api/club-settings", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      clubSlug,
      settings
    })
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Erreur lors de la mise \xE0 jour des param\xE8tres");
  }
  return await response.json();
}